export { default } from './StatusSidebarLink';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/StatusSidebarLink/index.js